import gql from 'graphql-tag';

export default gql`
query donation($id: ID!) {
    donation(id: $id) {
        name
        cms_url
        active_from
        active_to
        donation_total
        round_donated_count
        unique_donated_count
        not_donated_count
        dismissed_count
        # first_donation
        # last_donation
    }
}
`;

// TODO: Put first_donation and last_donation into response when backend fix is in


// WEBPACK FOOTER //
// ./src/api/graphql/queries/donation.ts